<template>
  <div>
    <div class="">
      <div class="border mb-1 p-2 bg-white shadow-sm"
           v-for="(c,i) in getSortedComments(task.task_data?.report?.comments ?? [])"
           :key="i">
        <div class="text_block" v-html="c.text"/>
        <p class="text-right fs-11">{{ c.user_name }} <span class="ml-1 text-muted">{{ printDate(c.created_at) }}</span>
        </p>
      </div>
    </div>
    <div class="flex mt-2 new_comment_block">
      <textarea v-model="comment" placeholder="Комментарий по задаче..." cols="4" class="form-control"/>
      <LoadingButton
        v-if="task.id"
        title="Сохранить комментарий"
        :loading="loading"
        :color="$constants.SUCCESS_COLOR"
        :onClick="() => saveComment()"
        className="btn btn-outline-success"
      />
    </div>
  </div>
</template>
<script>
import LoadingButton from "@/components/buttons/LoadingButton.vue";
import api from "@/api";
import {customUpdateData} from "@/eventsBus";

export default {
  components: {LoadingButton},
  props: ['task', 'updateTasks'],
  data() {
    return {
      loading: false,
      comment: ''
    }
  },
  computed: {
    $currentActiveRecords() {
      return this.$store.getters["recordsList/activeRecord"];
    },
  },
  methods: {
    getSortedComments(array) {
      return _.orderBy(array, 'created_at', 'desc');
    },
    async saveComment() {
      if (!this.comment) return;
      this.loading = true;
      const {data} = await api.post('/tasks/update', {
        type: 'addReport',
        task_id: this.task.id,
        comment: this.comment
      })
      if (data.success) {
        if (this.$currentActiveRecords?.id) {
          customUpdateData.$emit('updateListById', this.$currentActiveRecords.id);
        }
        if (this.updateTasks) await this.updateTasks();
        this.comment = '';
      }
      this.loading = false;
    }
  }
}
</script>

<style scoped>
.text_block {
  white-space: pre-line;
}

.new_comment_block {
  padding: 10px;
  background-color: lightgray;
}

.btn:not(:hover) {
  background-color: white;
}
</style>
